import { clsx } from 'clsx';
import type { ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Tailwind v4: we use numeric `text-{n}` utilities (e.g. `text-32`) and
 * custom `leading-lh{n}` utilities (e.g. `leading-lh3`) from our theme.
 *
 * Without extending tailwind-merge's theme, `text-32` may be treated as a
 * conflicting `text-*` utility and get dropped when combined with text color
 * classes like `text-text-primary`.
 */
const twMerge = extendTailwindMerge({
	extend: {
		theme: {
			text: ['40', '36', '32', '24', '20', '18', '16', '14', '12', '11', '10'],
			leading: ['lh1', 'lh2', 'lh3', 'lh4', 'lh5', 'lh6', 'lh7', 'lh8'],
		},
	},
});

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
